import { forwardRef, useImperativeHandle, useRef } from "react"

export const Dialog = forwardRef( function Dialog(props, ref) {
    const dialogRef = useRef(null)
   
    const openDialog = () => {
      dialogRef.current.showModal()
    }
  
    const closeDialog = () => {
      dialogRef.current.close()
    }
  
    useImperativeHandle(ref, () => ({
      open: openDialog,
      close: closeDialog,
    }))
  
    return (
      <dialog className="border-0 p-0 bg-transparent m-auto [&_.title]:flex [&_.title]:justify-between [&_.title]:items-center [&_.title]:mb-6 [&_.button-close]:absolute [&_.button-close]:top-4 [&_.button-close]:right-4 [&_.button-close]:bg-transparent [&_.button-close:hover]:bg-transparent [&_.button-close:hover_svg]:fill-opacity-100 [&_.button-close:hover_svg]:transition-[0.3s] [&_h1+p.description]:mt-0 [&_h1+p.description]:opacity-60 [&::backdrop]:bg-black/50" ref={dialogRef}>
        {props.children}
      </dialog>
    )
  })